import { Middleware } from 'redux';
import { WRITE_AUDIT_LOG, WriteAuditLogAction  } from './actions'; 
import { getDatabase } from 'database';
import * as logger from 'logger';

const AuditLogMiddleware: Middleware = store => next => async action => {
  try {
    switch (action.type) {

      case WRITE_AUDIT_LOG:
        await writeAuditLog(action);
        break;
  
      default:
        break;
    }
  
    next(JSON.parse(JSON.stringify(action)));
  }
  catch (e) {
    const error = e as Error;
    logger.error(error, 'AuditLogMiddleware');
  }
};

async function writeAuditLog(action: WriteAuditLogAction): Promise<void> {
  const db = await getDatabase();
  await db.add(db.config.indexes.AuditLog, action.auditLog, action.auditLog.id.toString());
}

export default AuditLogMiddleware;


// WEBPACK FOOTER //
// ./src/components/audit-logs/middleware.ts